type names =
	| 'transparent'
	| 'orange-primary'
	| 'orange-secondary'
	| 'orange-tertiary'
	| 'orange-quaternary'
	| 'orange-quinary'
	| 'brown-primary'
	| 'red-primary'
	| 'red-secondary'
	| 'red-tertiary'
	| 'red-quaternary'
	| 'blue-primary'
	| 'blue-secondary'
	| 'blue-tertiary'
	| 'gray-primary'
	| 'gray-secondary'
	| 'gray-tertiary'
	| 'gray-quaternary'
	| 'font-primary'
	| 'font-secondary'
	| 'font-tertiary'
	| 'font-quaternary'
	| 'black-primary'
	| 'white-primary'
	| 'warmgray-50'
	| 'warmgray-100'
	| 'warmgray-200'
	| 'warmgray-300'
	| 'warmgray-400'
	| 'warmgray-500'
	| 'warmgray-600'
	| 'warmgray-700'
	| 'warmgray-800'
	| 'warmgray-900'
	| 'warmgray-950'
	| 'gray02-50'
	| 'gray02-100'
	| 'gray02-200'
	| 'gray02-300'
	| 'gray02-400'
	| 'gray02-500'
	| 'gray02-600'
	| 'gray02-700'
	| 'gray02-800'
	| 'gray02-900'
	| 'gray02-950';

export type TColorNames = names & {};

export const COLORS = {
	transparent: 'transparent',

	'orange-primary': '#FF7305',
	'orange-secondary': '#FFD4B1',
	'orange-tertiary': '#FFEFDF',
	'orange-quaternary': '#FFF7F0',
	'orange-quinary': '#FFFBF9',

	'brown-primary': '#1E0F05',

	'red-primary': '#FF4C4C',
	'red-secondary': '#FDCACA',
	'red-tertiary': '#FEE2E2',
	'red-quaternary': '#FFF0F0',

	'blue-primary': '#5276FA',
	'blue-secondary': '#D4DDFF',
	'blue-tertiary': '#F3F6FF',

	'gray-primary': '#424242',
	'gray-secondary': '#A6A6A6',
	'gray-tertiary': '#E4E4E4',
	'gray-quaternary': '#F6F6F6',

	'font-primary': '#0E0D0C',
	'font-secondary': '#504C49',
	'font-tertiary': '#9B9694',
	'font-quaternary': '#DFDCDB',

	'black-primary': '#121212',
	'white-primary': '#FFFFFF',

	'warmgray-50': '#FAF7F6',
	'warmgray-100': '#EEE9E6',
	'warmgray-200': '#E1DAD7',
	'warmgray-300': '#D2C8C3',
	'warmgray-400': '#B9AFA9',
	'warmgray-500': '#A09691',
	'warmgray-600': '#8C827D',
	'warmgray-700': '#736964',
	'warmgray-800': '#5F5550',
	'warmgray-900': '#4B413C',
	'warmgray-950': '#372D23',

	'gray02-50': '#F6F6F6',
	'gray02-100': '#E7E7E7',
	'gray02-200': '#D1D1D1',
	'gray02-300': '#B0B0B0',
	'gray02-400': '#888888',
	'gray02-500': '#6D6D6D',
	'gray02-600': '#5D5D5D',
	'gray02-700': '#4F4F4F',
	'gray02-800': '#424242',
	'gray02-900': '#3D3D3D',
	'gray02-950': '#262626',
} as Record<TColorNames, string>;
